import React, { useEffect, useState } from "react";
import { useGuidedTour } from "@/lib/guidedTour";
import { useNarrationCue } from "@/components/clientDemo/tour/TourCuePointer";
import { PaycheckSplitCard, RentClearingCard, SavingsLoanCard, WaterfallCard } from "./ClearingCards";

export const CLEARING_CUES = [
  { phrase: "Every paycheck", target: "exchange-clearing-card-paycheck" },
  { phrase: "Rent is recouped", target: "exchange-clearing-card-rent" },
  { phrase: "savings bucket", target: "exchange-clearing-card-savings" },
  { phrase: "every dollar", target: "exchange-clearing-card-waterfall" },
];
const CARDS = [PaycheckSplitCard, RentClearingCard, SavingsLoanCard, WaterfallCard];

// Beat 06 — Clearinghouse & Financial Freedom; each card replays when the narration names it.
export default function ExchangeClearingSection() {
  const { isActive, current } = useGuidedTour();
  const live = isActive && current?.id === "beat06";
  const cue = useNarrationCue(CLEARING_CUES.map((c) => c.phrase), live);
  const [runs, setRuns] = useState([0, 0, 0, 0]);
  useEffect(() => {
    if (cue >= 0) setRuns((r) => r.map((n, i) => (i === cue ? n + 1 : n)));
  }, [cue]);

  return (
    <section data-testid="exchange-clearing-section" className="mt-8 rounded-3xl border border-[#D4AF37]/20 bg-[#0A0612] p-6 md:p-8">
      <div className="mb-6">
        <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#C9A227]">// 09 · Financial Freedom</div>
        <h2 className="mt-1 text-2xl md:text-3xl font-extrabold tracking-tight text-white">Clearinghouse &amp; Financial Freedom</h2>
      </div>
      <div className="flex gap-6">
        <div className="flex-1 min-w-0 grid grid-cols-1 md:grid-cols-2 gap-4">
          {CARDS.map((Card, i) => <Card key={i} run={runs[i]} active={live && cue === i} />)}
        </div>
        <aside data-testid="exchange-clearing-dock" className="hidden xl:flex w-[440px] shrink-0 rounded-2xl border border-dashed border-[#D4AF37]/25 bg-[#D4AF37]/[0.03] p-6 flex-col justify-center">
          <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[#C9A227]">From crisis to self-sufficiency</div>
          <ul className="mt-4 space-y-3 text-sm text-slate-300">
            {["Paychecks auto-split at clearing", "Rent recouped, landlords paid on time", "Savings grow, loans disappear", "Every dollar on the ledger"].map((t) => (
              <li key={t} className="flex items-start gap-2"><span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-[#D4AF37] shrink-0" />{t}</li>
            ))}
          </ul>
        </aside>
      </div>
    </section>
  );
}
